
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurance-home",
      function () {
        return require("private-next-pages/insurance-home.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insurance-home"])
      });
    }
  